import { AfterViewInit, Component, ElementRef, EventEmitter, Input, NgModule, Output, Renderer2, ViewChild } from '@angular/core';

import { CommonModule } from '@angular/common';
import { FacetPortfolioListDirective } from './facet-portfolio-list.directive';
import { WHideEmptyModule } from '@wipo/w-angular/directives';
import { WUniversalModule, document, isBrowser, WRxBase, toHeadingLevel, WHeadingLevel } from '@wipo/w-angular/shared';

@Component({
    selector: 'w-page-header',
    templateUrl: './w-page-header.component.html',
    host: {
        class: 'b-page-header b-page-header-update',
        '[class.b-page-header--has-portfolio]': 'hasPortfolio',
        '[style.text-transform]': 'disableUppercase ? "none": ""'
    },
    standalone: false
})
/*
@id w-page-header
@name w-page-header
@status release
@description
*/
export class WPageHeaderComponent extends WRxBase implements AfterViewInit {
  @ViewChild('portfolios', { static: false }) portfolio!: ElementRef<HTMLUListElement>;
  @ViewChild('p', { static: false }) p!: ElementRef<HTMLElement>;

  @Input() title = '';
  @Input() headingLevel: WHeadingLevel = 1; // title heading level 1-6 or 'h1'-'h6'
  @Input() subtitle = '';
  @Input() statusText = '';
  @Input() disableUppercase = false;
  @Input() showPortfolio = false;

  @Output() wShowMenu = new EventEmitter<boolean>();

  // following to compute position of portfolio element
  portfolioElement?: HTMLElement;
  clickAt: number = 0;
  portfolioWidth: number = 0;
  // get portfolioRight() {
  //   if (!isBrowser || !this.portfolioElement) { return ''; }
  //   return getComputedStyle(this.portfolioElement).direction !== 'rtl' && this.portfolioWidth < this.clickAt ? '0' : '';
  // }
  // get portfolioLeft() {
  //   if (!isBrowser || !this.portfolioElement) { return ''; }
  //   return getComputedStyle(this.portfolioElement).direction === 'rtl' && this.portfolioWidth < document.body.clientWidth - this.clickAt ? '0' : '';
  // }
  portfolioRight: string = '';
  portfolioLeft: string = '';

  hasPortfolio: boolean = false;
  clickUnlistener?: () => void;

  constructor(private renderer: Renderer2) { super(); }

  get level() {
    return toHeadingLevel(this.headingLevel, 1);
  }

  ngAfterViewInit(): void {
    this.runOnMutation(this.portfolio.nativeElement, { childList: true, subtree: true },
      this.refresh.bind(this), ['childList']);
    this.refresh();
    this.portfolioElement = this.p.nativeElement;
  }
  toggleMenu(event: MouseEvent) {
    event.stopPropagation();
    this.doShowPortfolio(!this.showPortfolio);
    setTimeout(() => {
      this.clickAt = event.x;
      this.portfolioWidth = this.portfolioElement?.clientWidth ?? 0;
    });
  }

  doShowPortfolio(state: boolean) {
    this.showPortfolio = state;
    this.wShowMenu.emit(state);
    if (state) {
      this.clickUnlistener = this.renderer.listen(window, 'click', (event: MouseEvent) => {
        if (!parentIs(event.target as HTMLElement, this.portfolio.nativeElement)) {
          this.doShowPortfolio(false);
        }
      });
    } else if (this.clickUnlistener) {
      this.clickUnlistener();
      this.clickUnlistener = undefined;
    }
  }
  refresh() {
    setTimeout(() => {
      this.hasPortfolio = isBrowser && this.portfolio?.nativeElement?.children?.length > 0;
      /** set position */
      if (this.portfolioElement && this.hasPortfolio){
       this.portfolioRight = getComputedStyle(this.portfolioElement).direction !== 'rtl' && this.portfolioWidth < this.clickAt ? '0' : '';
       this.portfolioLeft = getComputedStyle(this.portfolioElement).direction === 'rtl' && this.portfolioWidth < document.body.clientWidth - this.clickAt ? '0' : '';
      }
    });
  }
}
@NgModule({
  imports: [CommonModule, WHideEmptyModule, WUniversalModule],
  exports: [WPageHeaderComponent, FacetPortfolioListDirective],
  declarations: [WPageHeaderComponent, FacetPortfolioListDirective]
})
export class WPageHeaderModule { }
const parentIs = (el: HTMLElement, parent: HTMLElement): boolean => {
  const p = el.parentElement;
  if (p === parent) {
    return true;
  } else if (!p || p === el) {
    return false;
  } else {
    return parentIs(p, parent);
  }
};
